

<template>
  <!-- //chama o componente -->
  <TheNavBar/>
  <TheAbout/>
  <TheServices/>
  <TheCostumerService/>
  <TheWppLogoFlashing/>
  <TheInstaLogoPulse/>
  <TheTestimonials/>
  <TheFooter/>
  
</template>


<!-- //importa o componente -->
<script>

import TheWppLogoFlashing from './components/TheWppLogoFlashing.vue';
import TheNavBar from'./layout/TheNavBar.vue';
import TheAbout from'./layout/TheAbout.vue';
import TheServices from'./layout/TheServices.vue';
import TheInstaLogoPulse from './components/TheInstaLogoPulse.vue';
import TheTestimonials from './layout/TheTestimonials.vue';
import TheFooter from './layout/TheFooter.vue';
import '@/assets/css/main.css'
import TheCostumerService from './layout/TheCostumerService.vue';




// declara o componente
export default {
  name: 'App',
  components: {
    TheNavBar,
    TheAbout,
    TheServices,
    TheWppLogoFlashing,
    TheInstaLogoPulse,
    TheTestimonials,
    TheFooter,
    TheCostumerService
    
  
  }
  } 



</script>

<style>

</style>
